export const SAVE_USER = 'SAVE_USER';
export const SAVE_USER_PROFILE = 'SAVE_USER_PROFILE';
export const SAVE_USER_NOTIFICATION_SETTINGS = 'SAVE_USER_NOTIFICATION_SETTINGS';  
export const SAVE_USER_ACCOUNTS = 'SAVE_USER_ACCOUNTS';